<template>
  <div class="parlay-free">
    <template v-if="!showDesglose">
      <ParlayInfo @show="show" />
    </template>
    <template v-if="showDesglose">
      <ParlayDesglose @show="show" />
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'ParlayFree',
  components: {
    ParlayInfo: () => import('@/components/Sections/GolTipster-v2/General/ParlayInfo'),
    ParlayDesglose: () => import('@/components/Sections/GolTipster-v2/General/ParlayDesglose'),
  },
  data() {
    return { showDesglose: false };
  },
  computed: {
    ...mapState(['displayWidth']),
    isMobile() {
      return this.displayWidth < 464;
    },
  },
  watch: {},
  methods: {
    ...mapActions('betsGeneral', ['getParlayFree']),
    show() {
      this.showDesglose = !this.showDesglose;
    },
  },
  async created() {
    await this.getParlayFree();
  },
};
</script>

<style scoped lang="scss"></style>
